// extracted by mini-css-extract-plugin
export default {"leftNav":"NavPanel_leftNav__1zJXE","rightNav":"NavPanel_rightNav__C89h5","full":"NavPanel_full__L+Ey8"};